(function () {
  // Set a timeout to redirect if Angular hasn't loaded within 5 seconds
  setTimeout(function () {
    var appRoot = document.getElementsByTagName('app-root')[0];
    if (!appRoot || appRoot.getAttribute('ng-version') === null) {
      // If Angular hasn't added the ng-version attribute, redirect to unsupported browser page
      window.location.href = '/assets/html/unsupported-browser.html';
    }
  }, 30000);
})();
